<template>
    <v-footer app dark color="defaultTheme">
        <span>{{ $translator.language.data.layout.footer.copyright }}</span>
        <v-spacer />
        <v-btn @click="$vuetify.goTo(0)" color="primary" fab x-small dark>
            <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
    </v-footer>
</template>

<script>
export default {}
</script>
